import axios from "axios";

export default {
  name: "account-pay",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAccountPay(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "account_pay",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCreateAP(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url:
            process.env.VUE_APP_SERVICEURL + "account_pay/"+params.url,
          params:
          params.url == 'edit' ?
          {
            id_account_pay: params.id,
          } :
          {
            jenis_transaksi: params.type,
            id_invoice_ap_ad: params.id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getBuktiAP(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url:
            process.env.VUE_APP_SERVICEURL + "account_pay/list_bukti_transfer",
          params: {
            id: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    releaseQueue(store, { auth, id_ap, id, jenis_transaksi}) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "account_pay/rilis",
          data: {
            id_account_pay: id_ap,
            id: id,
            jenis_transaksi:jenis_transaksi
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createAP(store, { auth, data }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "account_pay",
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSpsclAccountPay(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "account_pay/fetch_data_AP_rilis",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getManifest(store, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "account_pay",
          params: { id_manifest: id, tlc:store.getters.getAuth.username },
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};
